import { render, staticRenderFns } from "./UnitSingle.vue?vue&type=template&id=ec08b2d0"
import script from "./UnitSingle.vue?vue&type=script&lang=js"
export * from "./UnitSingle.vue?vue&type=script&lang=js"
import style0 from "./UnitSingle.vue?vue&type=style&index=0&id=ec08b2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports